import { merge, of } from "rxjs";
import { toArray } from "rxjs/operators";
import { ServerResponseStatus } from "../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import { EntityBaseGqlService } from "../../api/EntityBaseGqlService.js";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import { map } from "../../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import { BulkOperationRequestBuilder } from "./requestBuilder.js";
class BulkOperationService extends EntityBaseGqlService {
  constructor(client, messageLocalizer) {
    super(client, new BulkOperationRequestBuilder(), messageLocalizer);
  }
  getErrorSeverity(_code) {
    return 0;
  }
  get(requestPayload) {
    const filterParams = new URLSearchParams(requestPayload?.filter);
    const invalidFilterKey = "invalid";
    const invalidFilterValue = filterParams.get(invalidFilterKey) === "true";
    const idFilterKey = "id";
    const idFilterValue = filterParams.get(idFilterKey);
    const bulkOperations = !invalidFilterValue ? idFilterValue?.split(/[,;|\s]/)?.map((id) => super.fetchData({ ...requestPayload, filter: `${idFilterKey}=${id}` })) : [];
    return !invalidFilterValue ? merge(...bulkOperations).pipe(
      toArray(),
      map((responses) => {
        let result;
        const isAvailableResponse = responses.every((r) => r.status === ServerResponseStatus.Success);
        if (isAvailableResponse) {
          const items = responses.reduce((p, c) => {
            const item = c.responsePayload?.getBulkOperationResult;
            return p.concat(item ? [item] : []);
          }, []);
          result = {
            status: ServerResponseStatus.Success,
            requestPayload,
            responsePayload: {
              items,
              total: items.length
            }
          };
        } else {
          result = {
            status: ServerResponseStatus.Failed,
            requestPayload,
            responsePayload: { items: [], total: 0 }
          };
        }
        return result;
      })
    ) : of({
      status: ServerResponseStatus.Success,
      requestPayload,
      responsePayload: { items: [], total: 0 }
    });
  }
}
export {
  BulkOperationService
};
//# sourceMappingURL=service.js.map
